module.exports = __webpack_public_path__ + "static/media/Amazon_logo.31aa9527.svg";